import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Appt Components
import ResponsiveGrid from '../../../components/compound/responsiveGrid/ResponsiveGrid.js'
import Box from '../../../components/simple/box/Box.js'
import Divider from '../../../components/simple/divider/Divider.js'
import Text from '../../../components/simple/text/Text.js'

// App widgets


import { Bar } from 'react-chartjs-2';
import SimpleCounter from '../../../components/compound/simpleCounter/SimpleCounter';

import LocalStorageService from '../../../services/LocalStorageService.js'
import { capitalize } from '../../../utils/text.js'
import { backgroundColours, borderColours } from '../common/colours.js'

const PILExtrasReport = props => {
  const navigate = useNavigate();
  const terms = LocalStorageService.get('terms') || {};

  const [totalNumberOfIncidentsByYearGroup, setTotalNumberOfIncidentsByYearGroup] = useState([])

  const [numBullyingUsers, setBullyingUsers] = useState([]);
  const [numRacistUsers, setRacistUsers] = useState([]);
  const [numSexistUsers, setSexistUsers] = useState([]);
  const [numHomophobicUsers, setHomophobicUsers] = useState([]);
  const [numBiphobicUsers, setBiphobicUsers] = useState([]);
  const [numTransphobicUsers, setTransphobicUsers] = useState([]);
  const [numDisabilityUsers, setDisabilityUsers] = useState([]);
  const [numDerogatoryUsers, setDerogatoryUsers] = useState([]);
  const [numSexualHarassmentUsers, setSexualHarassmentUsers] = useState([]);
  const [numStudentOnStudentUsers, setStudentOnStudentUsers] = useState([]);
  const [numSelfInjuriousUsers, setSelfInjuriousUsers] = useState([]);
  const [numSuspendedStudents, setSupendedStudents] = useState([]);
  const [numExpelledStudents, setExpelledStudents] = useState([]);
  const [numAssultOnStaffUsers, setAssultOnStaffUsers] = useState([]);
  const [numAbscondingUsers, setAbscondingUsers] = useState([]);
  const [numUnsafeUseOfEquipmentUsers, setUnsafeUseOfEquipmentUsers] = useState([]);

   const [numOfExtras, setnumOfExtras] = useState([]);
  const [relatedIncidents, setRelatedIncidents] = useState([]);

  // Incidents by Student Group
   const numberOfExtras = {
     labels: numOfExtras?.at(0)?.map(label => label === 'Student On Student' ? label.split('Student').join(capitalize(terms?.serviceUser || 'Service User')) : label),
     datasets: [
       {
         data: numOfExtras?.at(1),
         backgroundColor: backgroundColours,
         borderColor: borderColours,
         borderWidth: 1,
       },
     ],
   };

   const suspendedStudents = {
     labels: numSuspendedStudents?.at(0),
     datasets: [
       {
         data: numSuspendedStudents?.at(1),
         backgroundColor: backgroundColours,
         borderColor: borderColours,
         borderWidth: 1,
       },
     ],
   };
    const expelledStudents = {
      labels: numExpelledStudents?.at(0),
      datasets: [
        {
          data: numExpelledStudents?.at(1),
          backgroundColor: backgroundColours,
          borderColor: borderColours,
          borderWidth: 1,
        },
      ],
    };

  const bullyingUsers = {
    labels: numBullyingUsers?.at(0),
    datasets: [
      {
        data: numBullyingUsers?.at(1),
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };
   const racistUsers = {
     labels: numRacistUsers?.at(0),
     datasets: [
       {
         data: numRacistUsers?.at(1),
         backgroundColor: backgroundColours,
         borderColor: borderColours,
         borderWidth: 1,
       },
     ],
   };
    const sexistUsers = {
      labels: numSexistUsers?.at(0),
      datasets: [
        {
          data: numSexistUsers?.at(1),
          backgroundColor: backgroundColours,
          borderColor: borderColours,
          borderWidth: 1,
        },
      ],
    };
    const disabilityUsers = {
      labels: numDisabilityUsers?.at(0),
      datasets: [
        {
          data: numDisabilityUsers?.at(1),
          backgroundColor: backgroundColours,
          borderColor: borderColours,
          borderWidth: 1,
        },
      ],
    };
    const homophobicUsers = {
      labels: numHomophobicUsers?.at(0),
      datasets: [
        {
          data: numHomophobicUsers?.at(1),
          backgroundColor: backgroundColours,
          borderColor: borderColours,
          borderWidth: 1,
        },
      ],
    };
     const biphobicUsers = {
       labels: numBiphobicUsers?.at(0),
       datasets: [
         {
           data: numBiphobicUsers?.at(1),
           backgroundColor: backgroundColours,
           borderColor: borderColours,
           borderWidth: 1,
         },
       ],
     };
     const transphobicUsers = {
       labels: numTransphobicUsers?.at(0),
       datasets: [
         {
           data: numTransphobicUsers?.at(1),
           backgroundColor: backgroundColours,
           borderColor: borderColours,
           borderWidth: 1,
         },
       ],
     };
     const abscondingUsers = {
       labels: numAbscondingUsers?.at(0),
       datasets: [
         {
           data: numAbscondingUsers?.at(1),
           backgroundColor: backgroundColours,
           borderColor: borderColours,
           borderWidth: 1,
         },
       ],
     };
     const unsafeUseOfEquipmentUsers = {
       labels: numUnsafeUseOfEquipmentUsers?.at(0),
       datasets: [
         {
           data: numUnsafeUseOfEquipmentUsers?.at(1),
           backgroundColor: backgroundColours,
           borderColor: borderColours,
           borderWidth: 1,
         },
       ],
     };
     const derogatoryUsers = {
       labels: numDerogatoryUsers?.at(0),
       datasets: [
         {
           data: numDerogatoryUsers?.at(1),
           backgroundColor: backgroundColours,
           borderColor: borderColours,
           borderWidth: 1,
         },
       ],
     };
     const sexualHarassmentUsers = {
       labels: numSexualHarassmentUsers?.at(0),
       datasets: [
         {
           data: numSexualHarassmentUsers?.at(1),
           backgroundColor: backgroundColours,
           borderColor: borderColours,
           borderWidth: 1,
         },
       ],
     };
      const studentOnStudent = {
        labels: numStudentOnStudentUsers?.at(0),
        datasets: [
          {
            data: numStudentOnStudentUsers?.at(1),
            backgroundColor: backgroundColours,
            borderColor: borderColours,
            borderWidth: 1,
          },
        ],
      };
      const selfInjurious = {
        labels: numSelfInjuriousUsers?.at(0),
        datasets: [
          {
            data: numSelfInjuriousUsers?.at(1),
            backgroundColor: backgroundColours,
            borderColor: borderColours,
            borderWidth: 1,
          },
        ],
      };

      const assaultOnStaff = {
        labels: numAssultOnStaffUsers?.at(0),
        datasets: [
          {
            data: numAssultOnStaffUsers?.at(1),
            backgroundColor: backgroundColours,
            borderColor: borderColours,
            borderWidth: 1,
          },
        ],
      };

      // Incidents by Year Group
        const yeargroupData = {
          labels: totalNumberOfIncidentsByYearGroup[1],
          datasets: [
            {
              // label: '# of Votes',
              data: totalNumberOfIncidentsByYearGroup[0],
              backgroundColor: backgroundColours,
              borderColor: borderColours,
              borderWidth: 1,
            },
          ],
        };

  const printScreen = () => {
    window.print();
  };

  useEffect(() => {

    if (props?.reportData?.pilExtrasReport) {
      setnumOfExtras(props?.reportData?.pilExtrasReport);
    }

    if (props?.reportData?.pilExtrasByUserSuspension) {
      setSupendedStudents(props?.reportData?.pilExtrasByUserSuspension);
    }
    if (props?.reportData?.pilExtrasByUserPermanentExclusion) {
      setExpelledStudents(
        props?.reportData?.pilExtrasByUserPermanentExclusion,
      );
    }

    if (props?.reportData?.pilExtrasByUserTransphobic) {
      setTransphobicUsers(props?.reportData?.pilExtrasByUserTransphobic);
    }

    if (props?.reportData?.pilExtrasByUserAbsconding) {
      setAbscondingUsers(props?.reportData?.pilExtrasByUserAbsconding);
    }

    if (props?.reportData?.pilExtrasByUserUnsafeUseOfEquipment) {
      setUnsafeUseOfEquipmentUsers(props?.reportData?.pilExtrasByUserUnsafeUseOfEquipment);
    }

    if (props?.reportData?.pilExtrasByUserBiphobic) {
      setBiphobicUsers(props?.reportData?.pilExtrasByUserBiphobic);
    }

    if (props?.reportData?.pilExtrasByUserBullying) {
      setBullyingUsers(props?.reportData?.pilExtrasByUserBullying);
    }

    if (props?.reportData?.pilExtrasByUserDisability) {
      setDisabilityUsers(props?.reportData?.pilExtrasByUserDisability);
    }

    if (props?.reportData?.pilExtrasByUserHomophobic) {
      setHomophobicUsers(props?.reportData?.pilExtrasByUserHomophobic);
    }

    if (props?.reportData?.pilExtrasByUserRacist) {
      setRacistUsers(props?.reportData?.pilExtrasByUserRacist);
    }

    if (
      props?.reportData?.pilExtrasByUserSelfInjuriousBehaviour
    ) {
      setSelfInjuriousUsers(
        props?.reportData?.pilExtrasByUserSelfInjuriousBehaviour,
      );
    }

    if (
      props?.reportData?.pilExtrasByUserAssaultOnStaff
    ) {
      setAssultOnStaffUsers(
        props?.reportData?.pilExtrasByUserAssaultOnStaff,
      );
    }

    if (props?.reportData?.pilExtrasByUserSexist) {
      setSexistUsers(props?.reportData?.pilExtrasByUserSexist);
    }

    if (props?.reportData?.pilExtrasByUserSexualharassment) {
      setSexualHarassmentUsers(
        props?.reportData?.pilExtrasByUserSexualharassment,
      );
    }

    if (props?.reportData?.pilExtrasByUserStudentOnStudent) {
      setStudentOnStudentUsers(
        props?.reportData?.pilExtrasByUserStudentOnStudent,
      );
    }

    if (
      props?.reportData?.pilExtrasByUserUseOfDerogatoryLanguage
    ) {
      setDerogatoryUsers(
        props?.reportData?.pilExtrasByUserUseOfDerogatoryLanguage,
      );
    }

    // Year Group
    const totalNumberOfIncidentsByYearGroup = props?.reportData?.totalNumberOfIncidentsByYearGroup
    if (totalNumberOfIncidentsByYearGroup?.length) {
      const totalNumberOfIncidentsByYearGroupLabels = totalNumberOfIncidentsByYearGroup.map((data, index) => {
        return data.yearGroup || 'n/a'
      })

      const totalNumberOfIncidentsByYearGroupData = totalNumberOfIncidentsByYearGroup.map((data, index) => {
        return data.count
      })

      setTotalNumberOfIncidentsByYearGroup([totalNumberOfIncidentsByYearGroupData, totalNumberOfIncidentsByYearGroupLabels])
    }

    // if (props?.reportData?.incidentSearch) {
    //   setRelatedIncidents(props.reportData.incidentSearch);
    // }

  }, [props.reportData]);

  return (
    <Box width='xlarge' gap='medium' margin={{ bottom: 'medium' }}>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['50%', '50%'],
            medium: ['50%', '50%'],
            large: ['50%', '50%'],
            xlarge: ['50%', '50%'],
          }}
          gap="small"
          pad="xxsmall"
        >
          <SimpleCounter
            count={
              props?.reportData?.pilExtrasReportExclusions
                ? String(props.reportData.pilExtrasReportExclusions[1][0])
                : '0'
            }
            label="Suspensions"
            onClick={() => {
              props.addFilters([
                {
                  key: 'Suspension',
                  operator: 'is',
                  response: 'Yes',
                  relation: null
                }
              ]);
            }}
          />
          <SimpleCounter
            count={
              props?.reportData?.pilExtrasReportExclusions
                ? String(props.reportData.pilExtrasReportExclusions[1][1])
                : '0'
            }
            label=" Permanent Exclusion"
            onClick={() => {
              props.addFilters([
                {
                  key: 'PermanentExclusion',
                  operator: 'is',
                  response: 'Yes',
                  relation: null
                }
              ]);
            }}
          />
        </ResponsiveGrid>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['100%'],
            medium: ['100%'],
            large: ['100%'],
            xlarge: ['100%'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              Incidents
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numOfExtras?.length !== 0 ? (
              <Bar
                data={numberOfExtras}
                height={25}
                legend={{ display: false }}
                // options={{ maintainAspectRatio: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  let key = props?.reportData?.pilExtrasReport?.[0]?.[_index]
                  props.addFilter(key, '', 'exists');

                }}
                width={'100%'}
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>

          <Box
                      background='white'
                      direction='column'
                      pad='small'
                      // height="large"
                      round='small'
                    >
                      <Text size='medium' weight='bold'>Year Group</Text>
                      <Text margin={{ bottom: 'small' }} size='small'>Total number of Incidents</Text>
                      <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />

                      {totalNumberOfIncidentsByYearGroup.length !== 0
                        ? (
                          <Bar
                            data={yeargroupData}
                            height={125}
                            // options={{ maintainAspectRatio: false }}
                            legend={{ display: false }}
                            onClick={(event) => {
                              if (!event) return;
                              let element = getElementAtEvent(chartRefTwo.current, event)
                              let _index = element?.[0]?.index
                              let key = 'serviceuser_academicyear';
                              let value = props?.reportData?.totalNumberOfIncidentsByYearGroup?.[_index]?.yearGroup
                              props.addFilter(key, value);
                            }}

                          />)
                        : (
                          <Text textAlign='center'>Not enough data available</Text>
                        )}
                    </Box>
        </ResponsiveGrid>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              Suspensions
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numSuspendedStudents?.length !== 0 ? (
              <Bar
                data={suspendedStudents}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'Suspension',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              Permanent Exclusion
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numExpelledStudents?.length !== 0 ? (
              <Bar
                data={expelledStudents}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'PermanentExclusion',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                                }}legend={{ display: false }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['Bullying'] || "Bullying"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numBullyingUsers?.length !== 0 ? (
              <Bar
                data={bullyingUsers}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'Bullying',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}

                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['Racist'] || "Racist"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numRacistUsers?.length !== 0 ? (
              <Bar
                data={racistUsers}
                legend={false}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'Racist',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['Sexist'] || "Sexist"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numSexistUsers?.length !== 0 ? (
              <Bar
                data={sexistUsers}
                options={{
                  layout: {
                    legend: false
                  }
                }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'Sexist',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['Homophobic'] || "Homophobic"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numHomophobicUsers?.length !== 0 ? (
              <Bar
                data={homophobicUsers}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'Homophobic',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['Biphobic'] || "Biphobic"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numBiphobicUsers?.length !== 0 ? (
              <Bar
                data={biphobicUsers}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'Biphobic',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['Transphobic'] || "Transphobic"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numTransphobicUsers?.length !== 0 ? (
              <Bar
                data={transphobicUsers}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'Transphobic',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['Disability'] || "Disablist"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numDisabilityUsers?.length !== 0 ? (
              <Bar
                data={disabilityUsers}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'Disability',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['UseOfDerogatoryLanguage'] || "Derogatory Language Used"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numDerogatoryUsers?.length !== 0 ? (
              <Bar
                data={derogatoryUsers}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'UseOfDerogatoryLanguage',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['Sexualharassment'] || "Sexual Harassment"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numSexualHarassmentUsers?.length !== 0 ? (
              <Bar
                data={sexualHarassmentUsers}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'Sexualharassment',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>

        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['StudentOnStudent'] || `${capitalize(terms?.serviceUser || 'Service User')} On ${capitalize(terms?.serviceUser || 'Service User')}`}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numStudentOnStudentUsers?.length !== 0 ? (
              <Bar
                data={studentOnStudent}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'StudentOnStudent',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['SelfInjuriousBehaviour'] || "Self-injurious Behaviour"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numSelfInjuriousUsers?.length !== 0 ? (
              <Bar
                data={selfInjurious}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'SelfInjuriousBehaviour',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['AssaultOnStaff'] || "Assault on Staff"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numAssultOnStaffUsers?.length !== 0 ? (
              <Bar
                data={assaultOnStaff}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserSuspension?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'AssaultOnStaff',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['Absconding'] || "Absconding"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numAbscondingUsers?.length !== 0 ? (
              <Bar
                data={abscondingUsers}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserAbsconding?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'Absconding',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms['UnsafeUseOfEquipment'] || "Unsafe Use of Equipment"}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {numUnsafeUseOfEquipmentUsers?.length !== 0 ? (
              <Bar
                data={unsafeUseOfEquipmentUsers}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  props.addFilters([
                    {
                      key: 'studentName',
                      operator: 'is',
                      response: props?.reportData?.pilExtrasByUserUnsafeUseOfEquipment?.[2]?.[_index],
                      relation: null
                    },
                    {
                      key: 'UnsafeUseOfEquipment',
                      operator: 'exists',
                      response: '',
                      relation: null
                    }
                  ]);
                }}
                // width='400px'
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>
    </Box>
  );
};

export default PILExtrasReport;
